module.exports = __webpack_public_path__ + "staticcomp/img/content_1.b0ae9f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/1/content_1.jpg
// module id = ffes
// module chunks = 39